module.exports = __webpack_public_path__ + "static/img/201125-5.af08e44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/201125-5.jpg
// module id = odxJ
// module chunks = 0